import {Component} from "@angular/core";

@Component({
    selector: "fui-page-content-sections",
    styleUrls: ["./page-content-sections.component.scss"],
    templateUrl: "./page-content-sections.component.html"
})
export class FUIPageContentSectionsComponent {

}
